<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import File from "@/pages/components/form/input-only/file.vue";

export default {
	mixins: [formInput],
	components: {FormGroup, File},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'showCamera' : {
			type: Boolean,
			required: false,
			default: false
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>
		<template #label v-if="!$slots.label">
			{{ label }}
		</template>

		<File
			v-bind="$attrs"
			:form="form"
			type="file"
			:name="name"
			:id="renderedId"
			:model-value="modelValue"
			:show-camera="showCamera"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonbefore v-if="$slots.addonbefore"><slot name="addonbefore" /></template>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</File>
	</FormGroup>
</template>
